(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mrart-personalizados"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mrart-personalized')) {
    customElements.define('mrart-personalized', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.resize?.disconnect();
        const refreshers = [];
        this.resize = new ResizeObserver(() => refreshers.forEach(refresh => refresh()));
        this.querySelectorAll('[data-mrp-carousel]').forEach(carousel => {
          const track = carousel.querySelector('[data-mrp-track]');
          const controls = carousel.querySelector('[data-mrp-controls]');
          const prev = carousel.querySelector('[data-mrp-prev]');
          const next = carousel.querySelector('[data-mrp-next]');
          const update = () => {
            const limit = track.scrollWidth - track.clientWidth;
            const offset = Math.abs(track.scrollLeft);
            controls.hidden = limit < 3;
            prev.disabled = offset < 3;
            next.disabled = offset >= limit - 3;
          };
          const move = direction => {
            const rtl = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
            const first = track.firstElementChild;
            const amount = first ? first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
            track.scrollBy({ left: amount * direction * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          };
          prev.addEventListener('click', () => move(-1), { signal });
          next.addEventListener('click', () => move(1), { signal });
          track.addEventListener('scroll', update, { passive: true, signal });
          track.addEventListener('keydown', event => {
            if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }, { signal });
          refreshers.push(update);
          this.resize.observe(track);
          update();
        });
        const dialog = this.querySelector('dialog');
        this.addEventListener('click', event => {
          const link = event.target.closest('[data-mrp-zoom]');
          if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog?.showModal !== 'function') return;
          event.preventDefault();
          this.opener = link;
          const image = dialog.querySelector('[data-mrp-lightbox-image]');
          image.src = link.href;
          image.alt = link.querySelector('img')?.alt || link.dataset.mrpCaption || '';
          dialog.querySelector('[data-mrp-lightbox-caption]').textContent = link.dataset.mrpCaption || '';
          if (!dialog.open) dialog.showModal();
        }, { signal });
        dialog?.querySelector('[data-mrp-close]')?.addEventListener('click', () => dialog.close(), { signal });
        dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, { signal });
        dialog?.addEventListener('close', () => { this.opener?.focus({ preventScroll: true }); }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const block = event.target;
          if (!(block instanceof Element) || !this.contains(block)) return;
          const details = block.matches('details') ? block : block.closest('details');
          if (details) details.open = true;
          block.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'instant' });
        }, { signal });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.querySelector('dialog')?.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
/* Runs once per section file; Shopify reuses it when sections are reloaded. */
(() => {
  'use strict';
  const controllers = new Map();

  function initialize(slider) {
    if (controllers.has(slider)) return;
    const slides = Array.from(slider.querySelectorAll('[data-t4s-video-slide]'));
    if (!slides.length) return;

    const desktop = window.matchMedia('(min-width: 768px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const disposers = [];
    let frame = 0;
    let destroyed = false;
    const bounds = slider.getBoundingClientRect();
    let inView = bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 &&
      bounds.top < window.innerHeight && bounds.right > 0 && bounds.left < window.innerWidth;

    function listen(target, name, handler, options) {
      target.addEventListener(name, handler, options);
      disposers.push(() => target.removeEventListener(name, handler, options));
    }

    function watchMedia(query, handler) {
      if (query.addEventListener) listen(query, 'change', handler);
      else {
        query.addListener(handler);
        disposers.push(() => query.removeListener(handler));
      }
    }

    const records = slides.map(slide => ({
      slide,
      button: slide.querySelector('[data-video-toggle]'),
      intent: null,
      autoplay: slide.dataset.videoAutoplay === 'true',
      entries: Array.from(slide.querySelectorAll('.t4s-slideshow-video-layer')).map(layer => ({
        layer,
        video: layer.querySelector('video'),
        desired: false,
        pending: false,
        blocked: false
      })).filter(entry => entry.video)
    }));

    function activeEntry(record) {
      return record.entries.find(entry => entry.layer.dataset.videoViewport === 'all' ||
        entry.layer.dataset.videoViewport === (desktop.matches ? 'desktop' : 'mobile'));
    }

    function updateButton(record) {
      const entry = activeEntry(record);
      if (!record.button || !entry) return;
      const video = entry.video;
      const playing = !video.paused && !video.ended;
      const label = video.error ? 'Video no disponible' : playing ? 'Pausar video' :
        video.ended ? 'Volver a reproducir video' : 'Reproducir video';
      record.button.hidden = false;
      record.button.disabled = Boolean(video.error);
      record.button.setAttribute('aria-label', label);
      record.button.setAttribute('aria-controls', video.id);
      record.button.querySelector('[data-video-toggle-label]').textContent = label;
      record.button.querySelector('[data-video-play-icon]').toggleAttribute('hidden', playing);
      record.button.querySelector('[data-video-pause-icon]').toggleAttribute('hidden', !playing);
    }

    function sync() {
      frame = 0;
      if (destroyed) return;
      const selected = slider.querySelector('.t4s-slideshow-item.is-selected') ||
        slider.querySelector('.t4s-slideshow-item');

      records.forEach(record => {
        const active = activeEntry(record);
        // An explicit play click can override reduced motion; autoplay cannot.
        const wantsPlay = record.intent === 'play' || (record.intent !== 'pause' &&
          record.autoplay && !reducedMotion.matches);

        record.entries.forEach(entry => {
          const video = entry.video;
          const poster = desktop.matches ? entry.layer.dataset.posterDesktop : entry.layer.dataset.posterMobile;
          if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
          entry.desired = inView && !document.hidden && record.slide === selected &&
            entry === active && wantsPlay && !video.error;

          if (!entry.desired) {
            if (!video.paused || entry.pending) video.pause();
            return;
          }
          if (!video.paused || entry.pending || entry.blocked || (video.ended && !video.loop)) return;
          entry.pending = true;
          video.muted = true;
          try {
            const playback = video.play();
            if (playback && typeof playback.then === 'function') {
              playback.then(() => {
                entry.pending = false;
                // A slide can change before the browser finishes starting playback.
                if (destroyed || !entry.desired) video.pause();
                updateButton(record);
              }).catch(error => {
                entry.pending = false;
                if (error.name !== 'AbortError') entry.blocked = true;
                updateButton(record);
                if (error.name === 'AbortError' && entry.desired) schedule();
              });
            } else {
              entry.pending = false;
            }
          } catch (_) {
            entry.pending = false;
            entry.blocked = true;
          }
        });
        updateButton(record);
      });
    }

    function schedule() {
      if (!destroyed && !frame) frame = window.requestAnimationFrame(sync);
    }

    records.forEach(record => {
      record.entries.forEach(entry => {
        entry.video.muted = true;
        entry.video.defaultMuted = true;
        ['play', 'pause', 'ended', 'error'].forEach(name => listen(entry.video, name, () => updateButton(record)));
      });
      if (!record.button) return;
      // Keep the play control independent of Kalles' whole-slide link and drag.
      listen(record.button, 'pointerdown', event => event.stopPropagation());
      listen(record.button, 'click', event => {
        event.preventDefault();
        event.stopPropagation();
        const entry = activeEntry(record);
        if (!entry) return;
        record.intent = (!entry.video.paused && !entry.video.ended) || entry.pending ? 'pause' : 'play';
        if (record.intent === 'play') {
          entry.blocked = false;
          if (entry.video.ended) entry.video.currentTime = 0;
        }
        // Keep play() in the click call stack for browsers requiring a gesture.
        sync();
      });
    });

    const selectionObserver = new MutationObserver(mutations => {
      if (mutations.some(mutation => mutation.target === slider ||
          mutation.target.classList.contains('t4s-slideshow-item'))) schedule();
    });
    selectionObserver.observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });
    disposers.push(() => selectionObserver.disconnect());

    if ('IntersectionObserver' in window) {
      const visibilityObserver = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0 });
      visibilityObserver.observe(slider);
      disposers.push(() => visibilityObserver.disconnect());
    } else {
      const checkView = () => {
        const rect = slider.getBoundingClientRect();
        inView = rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
          rect.top < window.innerHeight && rect.right > 0 && rect.left < window.innerWidth;
        schedule();
      };
      listen(window, 'scroll', checkView, { passive: true });
      listen(window, 'resize', checkView);
    }

    watchMedia(desktop, schedule);
    watchMedia(reducedMotion, () => {
      if (reducedMotion.matches) records.forEach(record => {
        if (record.intent === 'play') record.intent = null;
      });
      schedule();
    });
    listen(document, 'visibilitychange', schedule);
    listen(slider, 'shopify:block:select', schedule);

    controllers.set(slider, () => {
      destroyed = true;
      if (frame) window.cancelAnimationFrame(frame);
      disposers.forEach(dispose => dispose());
      records.forEach(record => record.entries.forEach(entry => {
        entry.desired = false;
        entry.video.pause();
      }));
      controllers.delete(slider);
    });
    sync();
  }

  function initializeWithin(root) {
    root.querySelectorAll('.t4s-slideshow').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else initializeWithin(document);

  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((dispose, slider) => {
      if (event.target.contains(slider)) dispose();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
